/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    role: UserDTORoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    cardCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    profitCode?: string;
}


/**
 * @export
 */
export const UserDTORoleEnum = {
    User: 'user',
    Admin: 'admin',
    Supervisor: 'supervisor'
} as const;
export type UserDTORoleEnum = typeof UserDTORoleEnum[keyof typeof UserDTORoleEnum];


/**
 * Check if a given object implements the UserDTO interface.
 */
export function instanceOfUserDTO(value: object): value is UserDTO {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function UserDTOFromJSON(json: any): UserDTO {
    return UserDTOFromJSONTyped(json, false);
}

export function UserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'name': json['name'] == null ? undefined : json['name'],
        'surname': json['surname'],
        'username': json['username'],
        'company': json['company'] == null ? undefined : json['company'],
        'role': json['role'],
        'cardCode': json['card_code'] == null ? undefined : json['card_code'],
        'profitCode': json['profit_code'] == null ? undefined : json['profit_code'],
    };
}

export function UserDTOToJSON(json: any): UserDTO {
    return UserDTOToJSONTyped(json, false);
}

export function UserDTOToJSONTyped(value?: UserDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
        'name': value['name'],
        'surname': value['surname'],
        'username': value['username'],
        'company': value['company'],
        'role': value['role'],
        'card_code': value['cardCode'],
        'profit_code': value['profitCode'],
    };
}

